import {library} from '@fortawesome/fontawesome-svg-core'
import {
  faTimes,
  faSearchPlus,
  faSearchMinus,
  faExpand,
  faCompress,
  faAngleLeft,
  faAngleRight,
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {Toast} from 'vant'
import {createApp} from 'vue'
import VueLazyload from 'vue-lazyload'
import {router} from '@router/index'
import {store} from '@store/index'
import App from './App.vue'
import {stores} from './stores'
// import './registerServiceWorker'
import '@vant/touch-emulator'
// 2023.08.22
// - unplugin-vue-components not work as expected, without a global css import
//   component will lost styles
import 'vant/lib/index.css'
// Import Quick Tracking utility
import {initializeQuickTracking} from './utils/quick-tracking'

const app = createApp(App)

// store
// - old vuex store
app.use(store)

// stores
// - Date: 2023.09.08
// - New store, powered by Pinia
app.use(stores)

// router
app.use(router)

// VueLazyLoad
// - Date: 2023.09.08
// - Register VueLazyLoad globally
app.use(
  VueLazyload,
  {
    selector: 'img',
    loading: 'https://static.nuonuo.com.cn/zycmp/placeholder.png!/fw/440',
    error: 'https://static.nuonuo.com.cn/zycmp/placeholder.png!/fw/440',
  },
)

app.use(Toast)

// FontAwesomeIcon
// - Add icons to the library
library.add(
  faTimes,
  faSearchPlus,
  faSearchMinus,
  faExpand,
  faCompress,
  faAngleLeft,
  faAngleRight,
)
// - Register component globally
app.component(
  'FontAwesomeIcon',
  FontAwesomeIcon,
)

// Register Vue App
app.mount('#app')

// Quick Tracking
initializeQuickTracking()
